
    var riot = require('riot')
    
riot.tag2('personal_details', '<raw content="{opts.opts.personal_details}"></raw> <form class="form-horizontal"> <datepopover parent="{dateParent}" onupdate="{updateDate}"></datepopover> <popover parent="{infoParent}"> <raw content="{parent.info}"></raw> </popover> <div class="col-sm-6"> <h3>Your Personal Details </h3> <forminput label="Title" name="pers_title" value="{personal.pers_title}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_title)}"></forminput> <forminput label="First Name(s)*" name="pers_forenames" value="{personal.pers_forenames}" onupdate="{handleUpdate}" isrequired></forminput> <forminput label="Surname*" name="pers_surname" value="{personal.pers_surname}" onupdate="{handleUpdate}" isrequired></forminput> <forminput label="Contact Address*" name="pers_address1" value="{personal.pers_address1}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_address1)}" isrequired></forminput> <forminput label=" " name="pers_address2" value="{personal.pers_address2}" onupdate="{handleUpdate}"></forminput> <forminput label=" " name="pers_address3" value="{personal.pers_address3}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_address3)}"></forminput> <forminput label=" " name="pers_address4" value="{personal.pers_address4}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_address4)}"></forminput> <forminput label=" " name="pers_address5" value="{personal.pers_address5}" onupdate="{handleUpdate}"></forminput> <forminput label="Zip/Post Code*" name="pers_postcode" value="{personal.pers_postcode}" onupdate="{handleUpdate}" isrequired></forminput> <forminput label="Country*" name="pers_country" value="{personal.pers_country}" onupdate="{handleUpdate}" isrequired></forminput> <forminput label="Telephone" name="pers_telephone" value="{personal.pers_telephone}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_telephone)}"></forminput> <forminput label="Cell Phone" name="pers_mobile" value="{personal.pers_mobile}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_mobile)}"></forminput> <forminput label="Email*" name="pers_email" value="{personal.pers_email}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_email)}" isrequired></forminput> <fileinput label="Upload ID" name="pers_id" files="{personalFiles}" onupdate="{handleUpload}" onremove="{handleRemove}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_id)}" isrequired></fileinput> </div> <div class="col-sm-6"> <h3>Your Current Employment</h3> <forminput label="Position*" name="pers_position" value="{personal.pers_position}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_position)}" isrequired></forminput> <forminput label="Organisation*" name="pers_organisation" value="{personal.pers_organisation}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_organisation)}" isrequired></forminput> <formdateinput label="Date Joined*" name="pers_orgjoined" value="{personal.pers_orgjoined}" onupdate="{handleUpdate}" pattern="{datepattern}" dateformat="dd/MM/yyyy" isrequired></formdateinput> <forminput label="Address*" name="pers_orgaddress1" value="{personal.pers_orgaddress1}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_orgaddress1)}" isrequired></forminput> <forminput label=" " name="pers_orgaddress2" value="{personal.pers_orgaddress2}" onupdate="{handleUpdate}"></forminput> <forminput label=" " name="pers_orgaddress3" value="{personal.pers_orgaddress3}" onupdate="{handleUpdate}"></forminput> <forminput label=" " name="pers_orgaddress4" value="{personal.pers_orgaddress4}" onupdate="{handleUpdate}"></forminput> <forminput label=" " name="pers_orgaddress5" value="{personal.pers_orgaddress5}" onupdate="{handleUpdate}"></forminput> <forminput label="Zip/Post Code*" name="pers_orgpostcode" value="{personal.pers_orgpostcode}" onupdate="{handleUpdate}" isrequired></forminput> <forminput label="Country*" name="pers_orgcountry" value="{personal.pers_orgcountry}" onupdate="{handleUpdate}" isrequired></forminput> <forminput label="Telephone*" name="pers_orgtelephone" value="{personal.pers_orgtelephone}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_orgtelephone)}" isrequired></forminput> <forminput label="Email" name="pers_orgemail" value="{personal.pers_orgemail}" onupdate="{handleUpdate}" buttonafter="{infobutton}" buttonafterclick="{showInfo.bind(null, opts.infos.personal.pers_orgemail)}"></forminput> </div> </form>', '', '', function(opts) {
this.infobutton = "<span class=\"fa fa-info\" style=\"pointer-events:none\"></span>";

this.datepattern = '[0-9]{2}\/[0-9]{2}\/[0-9]{4}';

this.datebutton = "<span class=\"fa fa-calendar\" style=\"pointer-events:none\"></span>";

this.mounted = false;

this.on('mount', function() {
  this.mounted = true;
  if (opts.errors != null) {
    return setTimeout((function(_this) {
      return function() {
        return _this.checkErrors();
      };
    })(this));
  }
});

this.on('update', function() {
  if (opts.files != null) {
    this.personalFiles = opts.files.filter(function(f) {
      return f.path.match(/^id_/);
    });
  }
  if ((opts.errors != null) && this.mounted) {
    this.checkErrors();
  }
  if (opts.psedata != null) {
    return this.personal = opts.psedata.personal;
  }
});

this.checkErrors = (function(_this) {
  return function() {
    _this.personalErrors = opts.errors.filter(function(e) {
      return e.tab === 'personal';
    }).map(function(e) {
      return e.field;
    });
    return _this.personalErrors.forEach(function(field) {
      if (field === 'pers_orgjoined') {
        return _this.tags[field].tags['forminput'].tags['formgroup'].trigger('validate');
      } else {
        return _this.tags[field].tags['formgroup'].trigger('validate');
      }
    });
  };
})(this);

this.handleUpdate = (function(_this) {
  return function(val) {
    return opts.onupdate('personal', val.name, val.value);
  };
})(this);

this.handleUpload = (function(_this) {
  return function(val) {
    var data, file;
    if ((val != null ? val[0] : void 0) != null) {
      file = val[0];
      data = new FormData();
      data.append('file', file);
      data.append('name', 'id_' + file.name);
      return fetch('/duocms/api/pse/file', {
        method: 'POST',
        credentials: "include",
        headers: {
          'x-csrf-token': window.csrf
        },
        body: data
      }).then(function() {
        return opts.onupdate('files', 'add', {
          path: 'id_' + file.name
        });
      });
    }
  };
})(this);

this.handleRemove = (function(_this) {
  return function(file) {
    return fetch('/duocms/api/pse/file?path=' + file.path, {
      method: 'DELETE',
      credentials: "include",
      headers: {
        'x-csrf-token': window.csrf
      }
    }).then(function() {
      return opts.onupdate('files', 'remove', file);
    });
  };
})(this);

this.showDate = (function(_this) {
  return function(field, e) {
    _this.dateParent = e.target;
    _this.updateDate = function(val) {
      _this.personal[field] = val;
      return _this.update();
    };
    _this.tags.datepopover.handleClick(e);
    return _this.update();
  };
})(this);

this.showInfo = (function(_this) {
  return function(info, e) {
    _this.info = info;
    _this.infoParent = e.target;
    _this.tags.popover.clicked(e);
    return _this.update();
  };
})(this);
});
    
  